import React, { useState } from 'react';
import { Search, Filter, Plus, ChevronDown, MoreVertical, Mail, Phone, Edit, Trash2, UserPlus, Users, Shield, X, Check, User, Lock, Building, UserCog, Clock, AlertCircle } from 'lucide-react';
import { DepartmentSelector } from './DepartmentSelector';
export const UserManagement = ({
  activeDepartment,
  setActiveDepartment
}) => {
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isUserDetailsModalOpen, setIsUserDetailsModalOpen] = useState(false);
  // Filter users based on active tab and search query
  const filteredUsers = users.filter(user => {
    const matchesSearch = searchQuery === '' || user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase()) || user.department.toLowerCase().includes(searchQuery.toLowerCase());
    if (activeTab === 'all') return matchesSearch;
    if (activeTab === 'active') return user.status === 'Active' && matchesSearch;
    if (activeTab === 'pending') return user.status === 'Pending' && matchesSearch;
    if (activeTab === 'inactive') return user.status === 'Inactive' && matchesSearch;
    return matchesSearch;
  });
  const handleAddUser = () => {
    setIsAddUserModalOpen(true);
  };
  const handleViewUserDetails = user => {
    setSelectedUser(user);
    setIsUserDetailsModalOpen(true);
  };
  return <div className="p-6" data-id="element-1030">
      <div className="flex justify-between items-center mb-6" data-id="element-1031">
        <div className="flex items-center space-x-4" data-id="element-1032">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-1033">User Management</h1>
          <DepartmentSelector activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} data-id="element-1034" />
        </div>
        <button className="px-4 py-2 bg-blue-600 text-white rounded-md flex items-center space-x-2 hover:bg-blue-700 transition-colors" onClick={handleAddUser} data-id="element-1035">
          <Plus className="h-4 w-4" data-id="element-1036" />
          <span data-id="element-1037">Add User</span>
        </button>
      </div>
      <div className="flex items-center space-x-6 border-b border-gray-200 mb-6" data-id="element-1038">
        <button className={`py-3 px-1 ${activeTab === 'all' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('all')} data-id="element-1039">
          All Users
        </button>
        <button className={`py-3 px-1 ${activeTab === 'active' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('active')} data-id="element-1040">
          Active
        </button>
        <button className={`py-3 px-1 ${activeTab === 'pending' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('pending')} data-id="element-1041">
          Pending
        </button>
        <button className={`py-3 px-1 ${activeTab === 'inactive' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('inactive')} data-id="element-1042">
          Inactive
        </button>
      </div>
      <div className="flex justify-between items-center mb-6" data-id="element-1043">
        <div className="relative w-96" data-id="element-1044">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" data-id="element-1045" />
          <input type="text" placeholder="Search users..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1046" />
        </div>
        <div className="flex items-center space-x-4" data-id="element-1047">
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700" data-id="element-1048">
            <Filter className="h-4 w-4" data-id="element-1049" />
            <span data-id="element-1050">Filters</span>
            <ChevronDown className="h-4 w-4" data-id="element-1051" />
          </button>
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700" data-id="element-1052">
            <Clock className="h-4 w-4" data-id="element-1053" />
            <span data-id="element-1054">Last active</span>
            <ChevronDown className="h-4 w-4" data-id="element-1055" />
          </button>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-1056">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-1057">
          <thead className="bg-gray-50" data-id="element-1058">
            <tr data-id="element-1059">
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1060">
                User
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1061">
                Department
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1062">
                Role
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1063">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1064">
                Last Active
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1065">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-1066">
            {filteredUsers.map(user => <tr key={user.id} className="hover:bg-gray-50" data-id="element-1067">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1068">
                  <div className="flex items-center" data-id="element-1069">
                    <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-xs font-medium text-blue-800" data-id="element-1070">
                      {user.initials}
                    </div>
                    <div className="ml-4" data-id="element-1071">
                      <div className="text-sm font-medium text-gray-900 hover:text-blue-600 cursor-pointer" onClick={() => handleViewUserDetails(user)} data-id="element-1072">
                        {user.name}
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-1073">{user.email}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1074">
                  <div className="text-sm text-gray-900" data-id="element-1075">{user.department}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1076">
                  <div className="text-sm text-gray-900" data-id="element-1077">{user.role}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1078">
                  <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(user.status)}`} data-id="element-1079">
                    {user.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1080">
                  {user.lastActive}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1081">
                  <button className="text-blue-600 hover:text-blue-900 mr-3" onClick={() => handleViewUserDetails(user)} data-id="element-1082">
                    View
                  </button>
                  <button className="text-gray-600 hover:text-gray-900" data-id="element-1083">
                    <MoreVertical className="h-4 w-4" data-id="element-1084" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      {/* Add User Modal */}
      {isAddUserModalOpen && <AddUserModal onClose={() => setIsAddUserModalOpen(false)} data-id="element-1085" />}
      {/* User Details Modal */}
      {isUserDetailsModalOpen && selectedUser && <UserDetailsModal user={selectedUser} onClose={() => setIsUserDetailsModalOpen(false)} data-id="element-1086" />}
    </div>;
};
const AddUserModal = ({
  onClose
}) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    department: 'General Manager Office',
    role: 'User',
    status: 'Active'
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Here you would typically send the data to your backend
    console.log('Form submitted:', formData);
    onClose();
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-1087">
      <div className="bg-white w-full max-w-2xl rounded-lg shadow-xl overflow-hidden" data-id="element-1088">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-1089">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-1090">Add New User</h2>
          <button className="text-gray-500 hover:text-gray-700" onClick={onClose} data-id="element-1091">
            <X className="h-5 w-5" data-id="element-1092" />
          </button>
        </div>
        <form onSubmit={handleSubmit} data-id="element-1093">
          <div className="p-6" data-id="element-1094">
            <div className="grid grid-cols-2 gap-6" data-id="element-1095">
              <div data-id="element-1096">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1097">
                  Full Name*
                </label>
                <input type="text" name="name" required className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter full name" value={formData.name} onChange={handleChange} data-id="element-1098" />
              </div>
              <div data-id="element-1099">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1100">
                  Email Address*
                </label>
                <input type="email" name="email" required className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email address" value={formData.email} onChange={handleChange} data-id="element-1101" />
              </div>
              <div data-id="element-1102">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1103">
                  Department*
                </label>
                <select name="department" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.department} onChange={handleChange} data-id="element-1104">
                  <option value="General Manager Office" data-id="element-1105">
                    General Manager Office
                  </option>
                  <option value="Finance Department" data-id="element-1106">Finance Department</option>
                  <option value="HR Department" data-id="element-1107">HR Department</option>
                  <option value="IT Department" data-id="element-1108">IT Department</option>
                  <option value="Legal Department" data-id="element-1109">Legal Department</option>
                  <option value="Audit Department" data-id="element-1110">Audit Department</option>
                </select>
              </div>
              <div data-id="element-1111">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1112">
                  Role*
                </label>
                <select name="role" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.role} onChange={handleChange} data-id="element-1113">
                  <option value="Administrator" data-id="element-1114">Administrator</option>
                  <option value="Department Head" data-id="element-1115">Department Head</option>
                  <option value="Manager" data-id="element-1116">Manager</option>
                  <option value="User" data-id="element-1117">User</option>
                  <option value="Viewer" data-id="element-1118">Viewer</option>
                </select>
              </div>
              <div data-id="element-1119">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1120">
                  Status*
                </label>
                <select name="status" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.status} onChange={handleChange} data-id="element-1121">
                  <option value="Active" data-id="element-1122">Active</option>
                  <option value="Pending" data-id="element-1123">Pending</option>
                  <option value="Inactive" data-id="element-1124">Inactive</option>
                </select>
              </div>
              <div data-id="element-1125">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1126">
                  Phone Number
                </label>
                <input type="tel" name="phone" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone number (optional)" data-id="element-1127" />
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-1128">
              <h3 className="text-md font-medium text-gray-800 mb-4" data-id="element-1129">
                Permissions
              </h3>
              <div className="space-y-3" data-id="element-1130">
                <div className="flex items-center" data-id="element-1131">
                  <input type="checkbox" id="perm_documents" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500" defaultChecked data-id="element-1132" />
                  <label htmlFor="perm_documents" className="ml-2 text-sm text-gray-700" data-id="element-1133">
                    Document Management
                  </label>
                </div>
                <div className="flex items-center" data-id="element-1134">
                  <input type="checkbox" id="perm_workflows" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500" defaultChecked data-id="element-1135" />
                  <label htmlFor="perm_workflows" className="ml-2 text-sm text-gray-700" data-id="element-1136">
                    Workflow Management
                  </label>
                </div>
                <div className="flex items-center" data-id="element-1137">
                  <input type="checkbox" id="perm_archives" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500" defaultChecked data-id="element-1138" />
                  <label htmlFor="perm_archives" className="ml-2 text-sm text-gray-700" data-id="element-1139">
                    Archive Access
                  </label>
                </div>
                <div className="flex items-center" data-id="element-1140">
                  <input type="checkbox" id="perm_reports" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500" data-id="element-1141" />
                  <label htmlFor="perm_reports" className="ml-2 text-sm text-gray-700" data-id="element-1142">
                    Reporting & Analytics
                  </label>
                </div>
                <div className="flex items-center" data-id="element-1143">
                  <input type="checkbox" id="perm_users" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500" data-id="element-1144" />
                  <label htmlFor="perm_users" className="ml-2 text-sm text-gray-700" data-id="element-1145">
                    User Management
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3" data-id="element-1146">
            <button type="button" className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" onClick={onClose} data-id="element-1147">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-1148">
              Add User
            </button>
          </div>
        </form>
      </div>
    </div>;
};
const UserDetailsModal = ({
  user,
  onClose
}) => {
  const [activeTab, setActiveTab] = useState('profile');
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-1149">
      <div className="bg-white w-full max-w-4xl h-[90vh] rounded-lg flex flex-col overflow-hidden" data-id="element-1150">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-1151">
          <div className="flex items-center space-x-3" data-id="element-1152">
            <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-xs font-medium text-blue-800" data-id="element-1153">
              {user.initials}
            </div>
            <div data-id="element-1154">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-1155">
                {user.name}
              </h2>
              <p className="text-sm text-gray-500" data-id="element-1156">{user.email}</p>
            </div>
          </div>
          <button className="text-gray-500 hover:text-gray-700" onClick={onClose} data-id="element-1157">
            <X className="h-5 w-5" data-id="element-1158" />
          </button>
        </div>
        <div className="px-6 py-2 border-b border-gray-200 flex space-x-6" data-id="element-1159">
          <button className={`py-2 px-1 text-sm font-medium ${activeTab === 'profile' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('profile')} data-id="element-1160">
            Profile
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${activeTab === 'activity' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('activity')} data-id="element-1161">
            Activity
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${activeTab === 'permissions' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('permissions')} data-id="element-1162">
            Permissions
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${activeTab === 'settings' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('settings')} data-id="element-1163">
            Settings
          </button>
        </div>
        <div className="flex-1 overflow-auto" data-id="element-1164">
          {activeTab === 'profile' && <div className="p-6" data-id="element-1165">
              <div className="grid grid-cols-2 gap-6" data-id="element-1166">
                <div data-id="element-1167">
                  <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1168">
                    User Information
                  </h3>
                  <div className="space-y-4" data-id="element-1169">
                    <div className="flex items-start" data-id="element-1170">
                      <div className="w-32 text-sm text-gray-500" data-id="element-1171">
                        Full Name
                      </div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-1172">
                        {user.name}
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1173">
                      <div className="w-32 text-sm text-gray-500" data-id="element-1174">Email</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-1175">
                        {user.email}
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1176">
                      <div className="w-32 text-sm text-gray-500" data-id="element-1177">
                        Department
                      </div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-1178">
                        {user.department}
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1179">
                      <div className="w-32 text-sm text-gray-500" data-id="element-1180">Role</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-1181">
                        {user.role}
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1182">
                      <div className="w-32 text-sm text-gray-500" data-id="element-1183">Status</div>
                      <div className="flex-1" data-id="element-1184">
                        <span className={`px-2 py-1 text-xs rounded-full ${getStatusColor(user.status)}`} data-id="element-1185">
                          {user.status}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1186">
                      <div className="w-32 text-sm text-gray-500" data-id="element-1187">Phone</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-1188">
                        {user.phone || 'Not provided'}
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1189">
                      <div className="w-32 text-sm text-gray-500" data-id="element-1190">Created</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-1191">
                        {user.created || 'Aug 15, 2023'}
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1192">
                      <div className="w-32 text-sm text-gray-500" data-id="element-1193">
                        Last Active
                      </div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-1194">
                        {user.lastActive}
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-1195">
                  <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1196">
                    Actions
                  </h3>
                  <div className="flex flex-wrap gap-3" data-id="element-1197">
                    <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50" data-id="element-1198">
                      <Edit className="h-4 w-4" data-id="element-1199" />
                      <span data-id="element-1200">Edit User</span>
                    </button>
                    <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50" data-id="element-1201">
                      <Lock className="h-4 w-4" data-id="element-1202" />
                      <span data-id="element-1203">Reset Password</span>
                    </button>
                    <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-sm text-red-600 hover:bg-red-50" data-id="element-1204">
                      <Trash2 className="h-4 w-4" data-id="element-1205" />
                      <span data-id="element-1206">Deactivate User</span>
                    </button>
                  </div>
                  <div className="mt-8" data-id="element-1207">
                    <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1208">
                      Assigned Workflows
                    </h3>
                    <div className="space-y-3" data-id="element-1209">
                      <div className="border border-gray-200 rounded-lg p-4" data-id="element-1210">
                        <div className="flex justify-between items-start" data-id="element-1211">
                          <div data-id="element-1212">
                            <h4 className="text-sm font-medium text-gray-800" data-id="element-1213">
                              Annual Budget Approval
                            </h4>
                            <p className="text-xs text-gray-500 mt-1" data-id="element-1214">
                              In Progress • Due Sep 30, 2023
                            </p>
                          </div>
                          <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800" data-id="element-1215">
                            Reviewer
                          </span>
                        </div>
                      </div>
                      <div className="border border-gray-200 rounded-lg p-4" data-id="element-1216">
                        <div className="flex justify-between items-start" data-id="element-1217">
                          <div data-id="element-1218">
                            <h4 className="text-sm font-medium text-gray-800" data-id="element-1219">
                              Department Report Review
                            </h4>
                            <p className="text-xs text-gray-500 mt-1" data-id="element-1220">
                              Completed • Aug 12, 2023
                            </p>
                          </div>
                          <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800" data-id="element-1221">
                            Approver
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {activeTab === 'activity' && <div className="p-6" data-id="element-1222">
              <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1223">
                Recent Activity
              </h3>
              <div className="space-y-6" data-id="element-1224">
                {userActivities.map((activity, index) => <div key={index} className="flex" data-id="element-1225">
                    <div className="mr-4" data-id="element-1226">
                      <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-1227">
                        {getActivityIcon(activity.type)}
                      </div>
                    </div>
                    <div className="flex-1" data-id="element-1228">
                      <p className="text-sm text-gray-800" data-id="element-1229">
                        {activity.description}
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-1230">
                        {activity.date}
                      </p>
                      {activity.details && <div className="mt-2 p-3 bg-gray-50 rounded-md text-sm text-gray-700" data-id="element-1231">
                          {activity.details}
                        </div>}
                    </div>
                  </div>)}
              </div>
            </div>}
          {activeTab === 'permissions' && <div className="p-6" data-id="element-1232">
              <div className="flex justify-between items-center mb-4" data-id="element-1233">
                <h3 className="text-lg font-medium text-gray-800" data-id="element-1234">
                  User Permissions
                </h3>
                <button className="px-3 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 transition-colors flex items-center space-x-2" data-id="element-1235">
                  <Edit className="h-4 w-4" data-id="element-1236" />
                  <span data-id="element-1237">Edit Permissions</span>
                </button>
              </div>
              <div className="space-y-6" data-id="element-1238">
                <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1239">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-1240">
                    <thead className="bg-gray-50" data-id="element-1241">
                      <tr data-id="element-1242">
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1243">
                          Module
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1244">
                          Access Level
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1245">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-1246">
                      <tr data-id="element-1247">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1248">
                          <div className="flex items-center" data-id="element-1249">
                            <div className="h-8 w-8 bg-blue-100 rounded-md flex items-center justify-center text-blue-600" data-id="element-1250">
                              <FileText className="h-4 w-4" data-id="element-1251" />
                            </div>
                            <div className="ml-3 text-sm font-medium text-gray-900" data-id="element-1252">
                              Document Management
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1253">
                          Full Access
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1254">
                          <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800" data-id="element-1255">
                            Enabled
                          </span>
                        </td>
                      </tr>
                      <tr data-id="element-1256">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1257">
                          <div className="flex items-center" data-id="element-1258">
                            <div className="h-8 w-8 bg-purple-100 rounded-md flex items-center justify-center text-purple-600" data-id="element-1259">
                              <BarChart className="h-4 w-4" data-id="element-1260" />
                            </div>
                            <div className="ml-3 text-sm font-medium text-gray-900" data-id="element-1261">
                              Workflow Management
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1262">
                          Create & Edit
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1263">
                          <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800" data-id="element-1264">
                            Enabled
                          </span>
                        </td>
                      </tr>
                      <tr data-id="element-1265">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1266">
                          <div className="flex items-center" data-id="element-1267">
                            <div className="h-8 w-8 bg-yellow-100 rounded-md flex items-center justify-center text-yellow-600" data-id="element-1268">
                              <FolderOpen className="h-4 w-4" data-id="element-1269" />
                            </div>
                            <div className="ml-3 text-sm font-medium text-gray-900" data-id="element-1270">
                              Archive Access
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1271">
                          View Only
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1272">
                          <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800" data-id="element-1273">
                            Enabled
                          </span>
                        </td>
                      </tr>
                      <tr data-id="element-1274">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1275">
                          <div className="flex items-center" data-id="element-1276">
                            <div className="h-8 w-8 bg-green-100 rounded-md flex items-center justify-center text-green-600" data-id="element-1277">
                              <PieChart className="h-4 w-4" data-id="element-1278" />
                            </div>
                            <div className="ml-3 text-sm font-medium text-gray-900" data-id="element-1279">
                              Reporting & Analytics
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1280">
                          No Access
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1281">
                          <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-800" data-id="element-1282">
                            Disabled
                          </span>
                        </td>
                      </tr>
                      <tr data-id="element-1283">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1284">
                          <div className="flex items-center" data-id="element-1285">
                            <div className="h-8 w-8 bg-red-100 rounded-md flex items-center justify-center text-red-600" data-id="element-1286">
                              <Users className="h-4 w-4" data-id="element-1287" />
                            </div>
                            <div className="ml-3 text-sm font-medium text-gray-900" data-id="element-1288">
                              User Management
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1289">
                          No Access
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1290">
                          <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-800" data-id="element-1291">
                            Disabled
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4" data-id="element-1292">
                  <div className="flex items-start" data-id="element-1293">
                    <AlertCircle className="h-5 w-5 text-yellow-500 mt-0.5 mr-3" data-id="element-1294" />
                    <div data-id="element-1295">
                      <h4 className="text-sm font-medium text-yellow-800" data-id="element-1296">
                        Role-based Permissions
                      </h4>
                      <p className="text-sm text-yellow-700 mt-1" data-id="element-1297">
                        This user inherits permissions from the "{user.role}"
                        role. Any changes to the role will affect this user's
                        permissions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {activeTab === 'settings' && <div className="p-6" data-id="element-1298">
              <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1299">
                User Settings
              </h3>
              <div className="space-y-6" data-id="element-1300">
                <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg" data-id="element-1301">
                  <div data-id="element-1302">
                    <h4 className="text-sm font-medium text-gray-800" data-id="element-1303">
                      Email Notifications
                    </h4>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-1304">
                      Send email notifications for workflow assignments and
                      updates
                    </p>
                  </div>
                  <div className="relative inline-block w-12 h-6 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 bg-blue-600" data-id="element-1305">
                    <span className="absolute right-0 inline-block w-5 h-5 transform translate-x-0 bg-white rounded-full shadow ring-0 transition ease-in-out duration-200" data-id="element-1306"></span>
                  </div>
                </div>
                <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg" data-id="element-1307">
                  <div data-id="element-1308">
                    <h4 className="text-sm font-medium text-gray-800" data-id="element-1309">
                      Two-Factor Authentication
                    </h4>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-1310">
                      Require additional verification when signing in
                    </p>
                  </div>
                  <div className="relative inline-block w-12 h-6 border-2 border-gray-200 rounded-full cursor-pointer transition-colors ease-in-out duration-200 bg-gray-200" data-id="element-1311">
                    <span className="absolute left-0 inline-block w-5 h-5 transform translate-x-0 bg-white rounded-full shadow ring-0 transition ease-in-out duration-200" data-id="element-1312"></span>
                  </div>
                </div>
                <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg" data-id="element-1313">
                  <div data-id="element-1314">
                    <h4 className="text-sm font-medium text-gray-800" data-id="element-1315">
                      Session Timeout
                    </h4>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-1316">
                      Automatically log out after period of inactivity
                    </p>
                  </div>
                  <select className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1317">
                    <option value="30" data-id="element-1318">30 minutes</option>
                    <option value="60" data-id="element-1319">1 hour</option>
                    <option value="120" data-id="element-1320">2 hours</option>
                    <option value="240" data-id="element-1321">4 hours</option>
                  </select>
                </div>
                <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg" data-id="element-1322">
                  <div data-id="element-1323">
                    <h4 className="text-sm font-medium text-gray-800" data-id="element-1324">
                      Language Preference
                    </h4>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-1325">
                      Set the display language for this user
                    </p>
                  </div>
                  <select className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1326">
                    <option value="en" data-id="element-1327">English</option>
                    <option value="ar" data-id="element-1328">Arabic</option>
                    <option value="fr" data-id="element-1329">French</option>
                  </select>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};
// Helper functions
const getStatusColor = status => {
  switch (status) {
    case 'Active':
      return 'bg-green-100 text-green-800';
    case 'Pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'Inactive':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
const getActivityIcon = type => {
  switch (type) {
    case 'login':
      return <User className="h-4 w-4" data-id="element-1330" />;
    case 'document':
      return <FileText className="h-4 w-4" data-id="element-1331" />;
    case 'workflow':
      return <BarChart className="h-4 w-4" data-id="element-1332" />;
    case 'permission':
      return <Shield className="h-4 w-4" data-id="element-1333" />;
    default:
      return <Clock className="h-4 w-4" data-id="element-1334" />;
  }
};
// Sample data
const users = [{
  id: 1,
  name: 'Jasim Alawadhi',
  email: 'jasim.alawadhi@example.com',
  initials: 'JA',
  department: 'General Manager Office',
  role: 'Administrator',
  status: 'Active',
  lastActive: 'Today, 10:30 AM',
  phone: '+971 50 123 4567',
  created: 'Jan 15, 2023'
}, {
  id: 2,
  name: 'Fatima Ahmed',
  email: 'fatima.ahmed@example.com',
  initials: 'FA',
  department: 'Finance Department',
  role: 'Department Head',
  status: 'Active',
  lastActive: 'Today, 9:45 AM'
}, {
  id: 3,
  name: 'Mohammed Ali',
  email: 'mohammed.ali@example.com',
  initials: 'MA',
  department: 'HR Department',
  role: 'Manager',
  status: 'Active',
  lastActive: 'Yesterday'
}, {
  id: 4,
  name: 'Noura Abdullah',
  email: 'noura.abdullah@example.com',
  initials: 'NA',
  department: 'IT Department',
  role: 'User',
  status: 'Active',
  lastActive: 'Aug 15, 2023'
}, {
  id: 5,
  name: 'Ahmed Khalid',
  email: 'ahmed.khalid@example.com',
  initials: 'AK',
  department: 'Legal Department',
  role: 'User',
  status: 'Pending',
  lastActive: 'Never'
}, {
  id: 6,
  name: 'Hiba Ali',
  email: 'hiba.ali@example.com',
  initials: 'HA',
  department: 'HR Department',
  role: 'User',
  status: 'Active',
  lastActive: 'Aug 14, 2023'
}, {
  id: 7,
  name: 'Omar Hassan',
  email: 'omar.hassan@example.com',
  initials: 'OH',
  department: 'Audit Department',
  role: 'Manager',
  status: 'Inactive',
  lastActive: 'Jul 28, 2023'
}, {
  id: 8,
  name: 'Layla Mohammed',
  email: 'layla.mohammed@example.com',
  initials: 'LM',
  department: 'Finance Department',
  role: 'User',
  status: 'Active',
  lastActive: 'Aug 16, 2023'
}];
const userActivities = [{
  type: 'login',
  description: 'Logged in to the system',
  date: 'Today, 10:30 AM'
}, {
  type: 'document',
  description: 'Uploaded document "Annual Report 2023.pdf"',
  date: 'Today, 11:15 AM',
  details: 'File uploaded to Finance Department > Reports > 2023'
}, {
  type: 'workflow',
  description: 'Started workflow "Annual Budget Approval"',
  date: 'Today, 1:45 PM'
}, {
  type: 'document',
  description: 'Viewed document "Financial Statement Q2.pdf"',
  date: 'Yesterday, 3:20 PM'
}, {
  type: 'workflow',
  description: 'Completed task "Department Review" in "Project Proposal Review" workflow',
  date: 'Yesterday, 4:10 PM',
  details: 'Added comment: "Approved with minor changes. Please update section 3 with the latest figures."'
}, {
  type: 'permission',
  description: 'Permission updated for "Archive Access"',
  date: 'Aug 15, 2023',
  details: 'Access level changed from "No Access" to "View Only"'
}];
// Importing FolderOpen for the user details modal
import { FolderOpen, PieChart } from 'lucide-react';